module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Tablet.f539ca5c.jpg";